import React from 'react';
import { connect } from 'react-redux';
import { toastr } from 'react-redux-toastr';
import {
  Form,
  Input,
  Typography,
  Row,
  Col,
  Button,
  Modal,
  Checkbox,
  Avatar
} from 'antd';
import { required, whiteSpace, maxLengthC } from '../../../../config/FormValidation'
import { loadingAction,  sendMessageAction } from '../../../../store/actions'
import { langs } from '../../../../config/localization';
import { MESSAGES } from '../../../../config/Message'
import { dateFormate8 } from '../../../common/index'
import { UserOutlined } from '@ant-design/icons';
const { Text, Paragraph } = Typography;
const { TextArea } = Input;

const layout = {
  labelCol: { span: 7 },
  wrapperCol: { span: 17 },
  labelAlign: 'left',
  colon: false,
  className: "sellerContact"
};
const tailLayout = {
  wrapperCol: { span: 24 },
  className: 'align-center pt-20'
};

class ContactModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      inspection: 0,
      price: 0,
      sales: 0,
      property: 0,
      count: 1500
    };
  }

  /**
   * @method onFinish
   * @description handle on submit
   */
  onFinish = (values) => {

    this.props.loadingAction(true)
    const { flag, receiverId, classifiedid, contactType } = this.props;

    const { sales, price, property, inspection } = this.state
    const requestData = {
      classifieduser_id: receiverId,
      classifiedid: classifiedid,
      massage: values.message,
    }
    if (contactType === 'realstate') {
      requestData.inspection_times = flag ? 1 : inspection ? 1 : 0
      requestData.price_guide = price ? 1 : 0
      requestData.contract_of_sale = sales ? 1 : 0
      requestData.similar_properties = property ? 1 : 0
    }

    this.props.sendMessageAction(requestData, res => {
      this.props.loadingAction(false)
      if (res.success) {
        toastr.success(langs.success, MESSAGES.MESSAGE_SENT_SUCCESS)
        this.props.onCancel()
      }
    })
  }

  /**
   * @method handleInspection
   * @description handle inspection
   */
  handleInspection = (e) => {
    this.setState({ inspection: e.target.checked })
  }

  /**
   * @method handleProperty
   * @description handle property
   */
  handleProperty = (e) => {
    this.setState({ property: e.target.checked })
  }

  /**
   * @method handleSale
   * @description handle sale
   */
  handleSale = (e) => {
    this.setState({ sales: e.target.checked })
  }

  /**
   * @method handlePrice
   * @description handle price
   */
  handlePrice = (e) => {
    this.setState({ price: e.target.checked })
  }

  /**
   * @method handleTextAreaChange
   * @description handle text area change
   */
  handleTextAreaChange = ({ target: { value } }) => {
    let count = ''
    if (value.length <= 1500) {
      count = 1500 - value.length
    } else {
      count = 0
    }
    this.setState({ message: value, count: count });
  };

  /**
   * @method render
   * @description render component
   */
  render() {
    const { flag, visible, classifiedDetail, userDetails, contactType, pageURL, pageName } = this.props;

    const { inspection, count } = this.state
    return (
      <Modal
        title={contactType === 'realstate' ? 'Send Enquiry' : 'Contact to advertiser'}
        visible={visible}
        className={`${pageURL ? pageURL : pageName} primaryModal contactSeller`}
        footer={false}
        onCancel={this.props.onCancel}
        width={750}
      >
        {contactType === 'realstate'
          ? <div style={{ marginBottom: "25px" }}><Text className='strong'>{classifiedDetail.location}</Text></div>
          : <>
            <div className='sellerHeader'>
              <label><strong>To:</strong></label>
              {(classifiedDetail?.classified_users?.userimage || classifiedDetail?.image)
                ? <Avatar size={55} src={classifiedDetail?.image ?? classifiedDetail.classified_users.userimage} />
                : <Avatar size={55} icon={<UserOutlined />} />
              }
              <div className='userSummary'>
                <Text strong type='secondary'>
                  {classifiedDetail?.classified_users?.name ?? classifiedDetail?.name}
                </Text>
                <Paragraph type='secondary'>
                  {
                    `Member since ${classifiedDetail?.classified_users?.member_since
                      ? classifiedDetail.classified_users.member_since
                      : classifiedDetail?.member_since ?? dateFormate8(classifiedDetail.classified_users.created_at)}`
                  }
                </Paragraph>
              </div>
            </div>
          </>
        }

        <Form
          {...layout}
          onFinish={this.onFinish}
        >
          <Form.Item label='Name' name='name'>
            <Input disabled={userDetails.name ? true : false} placeholder="..." defaultValue={userDetails.name && userDetails.name} />
          </Form.Item>
          {contactType !== undefined && contactType === 'realstate'
            && <Row style={{ marginBottom: "30px" }}>
              <Col className="emptyCol" xs={{ span: 7 }}></Col>
              <Col className="emptyColTwo" xs={{ span: 17 }}>
                <Text strong>Please send me more information regarding</Text>
                <Row gutter={[10, 10]}>
                  <Col xs={{ span: 12 }}>
                    <Checkbox checked={flag ? true : inspection ? true : false} onChange={this.handleInspection}>Inspection times</Checkbox>
                  </Col>
                  <Col xs={{ span: 12 }}>
                    <Checkbox onChange={this.handleSale}>Contract of sale</Checkbox>
                  </Col>
                  <Col xs={{ span: 12 }}>
                    <Checkbox onChange={this.handlePrice}>Price guide</Checkbox>
                  </Col>
                  <Col xs={{ span: 12 }}>
                    <Checkbox onChange={this.handleProperty}>Similar properties</Checkbox>
                  </Col>
                </Row>
              </Col>
            </Row>}

          <Form.Item
            label={<>Body of message (1500)<br /><span className='less-count-red'>{count}</span> characters remaining</>}
            name='message'
            className='Message'
            rules={[required(''), whiteSpace('Message'), maxLengthC(1500)]}
          >
            <TextArea
              rows={6}
              placeholder={'Write your message here'}
              onChange={this.handleTextAreaChange}
            />
          </Form.Item>
          <Form.Item {...tailLayout}>
            <Button type='default' htmlType='submit' className='retail'>
              Send
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    );
  }
}

//  Connect with redux through connect methode
const mapStateToProps = (store) => {
  const { auth, profile } = store;
  return {
    loggedInDetail: auth.loggedInUser,
    userDetails: profile.userProfile !== null ? profile.userProfile : {}
  };
};

export default connect(mapStateToProps, { sendMessageAction, loadingAction,  })(ContactModal);
